export const EOperationTypes = {
  ADHESION: 'adhesion',
  SIMPLE_CHANGE: 'simpleChange',
  COMPLETE_CHANGE: 'completeChange',
  SUSPENSION: 'suspension',
  REACTIVATION: 'reactivation'
} as const;

export type EOperationTypes =
  (typeof EOperationTypes)[keyof typeof EOperationTypes];
